import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';


@Component({
  selector: 'app-merchant-messages',
  templateUrl: './merchant-messages.component.html',
  styleUrls: ['./merchant-messages.component.scss']
})
export class MerchantMessagesComponent implements OnInit {


  searchText:string = '';

  merchantId:string = "6a4dfe9fdb983fa57a3fcdb0";


  conversations:any[] = [];

  filteredConversations:any[] = [];

  selectedChat:any = null;

  messages:any[] = [];

  messageText:string = '';



  constructor(
    private apiService:ApiServiceService
  ){}



  ngOnInit(){

    this.loadConversations();

  }



  loadConversations(){

    this.apiService
    .getMerchantConversations(this.merchantId)
    .subscribe((res:any)=>{


      this.conversations =
      res.data.map((item:any)=>{

        return {

          id:item._id,
          user_id:item.user_id,

          name:
item.user_id.basic_info.first_name
+
" "
+
item.user_id.basic_info.last_name,

          lastMessage:item.last_message,

          time:new Date(item.last_message_time)
          .toLocaleTimeString([],{
            hour:'2-digit',
            minute:'2-digit'
          }),

          unread:item.user_unread,

          conversationId:item._id

        };


      });


      this.filteredConversations =
      this.conversations;


      if(this.conversations.length>0){

        this.selectConversation(this.conversations[0]);

      }


    });


  }





  selectConversation(chat:any){


    this.selectedChat = chat;


    this.apiService
    .getMerchantMessages(chat.conversationId)
    .subscribe((res:any)=>{


      this.messages =
      res.data.map((msg:any)=>{


        return {

          sender:
          msg.sender_type === "merchant"
          ? "merchant"
          :"customer",

          text:msg.message,

          time:new Date(msg.created_at)
          .toLocaleTimeString([],{
            hour:'2-digit',
            minute:'2-digit'
          })

        };


      });


    });



    chat.unread=0;



    this.apiService
    .markMerchantMessagesRead(chat.conversationId)
    .subscribe();


  }





  searchConversation(){


    const value =
    this.searchText.toLowerCase();



    this.filteredConversations =
    this.conversations.filter((chat)=>{


      return chat.name
      .toLowerCase()
      .includes(value);


    });


  }





  sendMessage(){


    if(!this.messageText.trim()){
      return;
    }



    const data={

      merchant_id:this.merchantId,

      user_id:this.selectedChat.user_id,

      message:this.messageText

    };



    this.apiService
    .sendMerchantMessage(data)
    .subscribe((res:any)=>{


      this.messages.push({

        sender:"merchant",

        text:this.messageText,

        time:new Date()
        .toLocaleTimeString([],{
          hour:'2-digit',
          minute:'2-digit'
        })

      });


      this.messageText='';


    });


  }



}